import { useState } from 'react';
import { adminAPI } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { toast } from 'sonner';
import { Clock } from 'lucide-react';

export function TrialPeriodCard({ config, setConfig, readOnly = false }) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
          <Clock className="w-5 h-5 text-yellow-500" />
          Periodo di Prova
        </CardTitle>
        <CardDescription>
          {readOnly ? 'Durata del periodo di prova gratuito' : 'Configura la durata del periodo di prova gratuito'}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center gap-4">
          <div className="space-y-2 w-48">
            <Label>Giorni di prova</Label>
            <Input
              data-testid="trial-days-input"
              type="number"
              min={1}
              value={config?.trial_days || 14}
              onChange={(e) => !readOnly && setConfig({ ...config, trial_days: parseInt(e.target.value) || 14 })}
              disabled={readOnly}
              className={readOnly ? 'bg-muted' : ''}
            />
          </div>
          <p className="text-sm text-muted-foreground mt-6">
            I nuovi utenti avranno {config?.trial_days || 14} giorni di prova gratuita.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
